import {call, put} from 'redux-saga/effects';
import {createPubEditor} from 'services/pubs';
import {handleError} from 'store/app/error/saga';

import {getSingleEditorACS, assignPubACS} from '../requestAC';

export function* assignPubSaga(action: ReturnType<typeof assignPubACS>) {
  const {userId} = action.payload;

  try {
    yield call(createPubEditor, action.payload);
    yield put(getSingleEditorACS(userId.toString()));
  } catch (error) {
    yield call(handleError, error, 'Failed to add pub to editor');
  }
}
